// extracted by mini-css-extract-plugin
export var shake = "_c-0";